import PageLayout from '../../common/components/PageLayout/PageLayout'
import References from '../../common/components/References/References'
import TextRef from '../../common/components/TextRef/TextRef'
import Title from '../../common/components/Title/Title'
import Video from '../../common/components/Video/Video'
import ImagesCarousel from '../../common/components/ImagesCarousel/ImagesCarousel'
import Images from '../../common/Images'
import './CommAndEducation.css'
import ImageWithCaption from '../../common/components/ImageWithCaption/ImageWithCaption'
import MarginDecoration from '../../common/components/MarginDecoration/MarginDecoration'

function CommAndEducation () {
  const imagesSummerCamp = [
    Images.Education_summer_camp1,
    Images.Education_summer_camp2,
    Images.Education_summer_camp3,
    Images.Education_summer_camp4
  ]
  const imagesDidYouKnow = [
    Images.Education_did_you_know3,
    Images.Education_did_you_know1,
    Images.Education_did_you_know4,
    Images.Education_did_you_know2,
    Images.Education_did_you_know5
  ]

  return (
    <PageLayout title="Communication & Education">
      <MarginDecoration />
      <Title title="Bio-Bio-Bio talk show" isSub />
      <p>
        As iGEM team members, we understand the positive impact of
        extracurricular activities on building character. It is our belief that
        extracurricular activities should be advertised and accessible to all.
        This year, iGEM ULaval sent 2 of its members to meet with the{' '}
        <i>
          Bio-Bio-Bio talk show
          <TextRef sup="[1]" content="" />
        </i>{' '}
        student podcast crew. Together, they recorded a special podcast episode
        which is currently available on Spotify. The goal of this collaboration
        is to share the experience of our members with the student population,
        which is the main audience of this podcast, as well as to prompt
        students to go seek an extracurricular activity of their liking. During
        this episode, we talk about the iGEM Grand Jamboree experience, the iGEM
        work cycle, and our 2022 iGEM project. Additionally, we discuss the
        extracurricular skills that participation in an iGEM team develops, such
        as scientific communication, marketing, public relations, social media
        management.
      </p>
      <br />
      <Title title="World Health Day" isSub />
      <p>
        We participated in the creation of a promotional post on social media
        for World Health Day in collaboration with other iGEM teams. This
        initiative, led by the iGEM team Patras Medicine, included 26 different
        teams. They each wrote a powerful quote from renowned scientists on
        posters and took pictures of team members holding these posters. The
        pictures from each team were then collected and posted on social media,
        reaching hundreds of people across the world.
      </p>{' '}
      <div className="national-dna-day-image">
        <ImageWithCaption
          imagePadding={20}
          captionPadding={0}
          src={Images.Education_health_day}
          caption="Promotional poster created by team members Arnaud, Mathieu and Raphaël for World Health Day."
        />
      </div>
      <br />
      <Title title="National DNA Day" isSub />
      <p>
        For National DNA Day, on April 25 2023, we participated in a
        collaboration led by iGEM Patras Medecine with more than 15 teams from
        around the world. Each team had to present a story, a fact or a use of
        DNA. We produced one such video, which was then put together with the
        others to create a cohesive result. The compilation was shared on social
        media by all participants, reaching at least hundreds of people
        internationally.{' '}
      </p>
      <Video
        videos={[
          {
            title: 'ULaval: National_DNA_Day (2023) [English]',
            url: 'https://video.igem.org/videos/embed/881e24db-4aeb-46c2-8533-0745d6b1b2a6'
          }
        ]}
        figureLegend={<>National DNA Day</>}
      />
      <p>
        <br />
        <Title
          title="Patro de Charlesbourg - Summer Camp Science Outreach Activity"
          isSub
        />
      </p>
      <p>
        Biology is fascinating and it is our team&apos;s belief that science
        should be accessible to everyone. On July 20 2023, our iGEM team sent 4
        members to spend a day at the Patro de Charlesbourg day camp to share
        our passion for science. The Patro de Charlesbourg is a non-profit
        organization offering fun and educational activities during the summer
        or school holidays. There, we organised and executed a genetics-themed
        science outreach activity for children between 9 and 11 years old. The
        title of this activity was <i>The secret code of life</i>. This workshop
        consisted of a short interactive presentation on genetics, fun puzzles
        about DNA, and a large capture-the-flag game. All in all, our team was
        able to reach around 750 kids and teenagers.
      </p>
      <ImagesCarousel images={imagesSummerCamp} />
      <Title title="Educating the general public about blood" isSub />
      <p>
        For multiple weeks, we published weekly informative posts on social
        media about blood cells and blood in general. Shared on the team&apos;s
        instagram and facebook pages, the publications, with a reach of over 500
        people, aimed to educate the general public on the subject through fun
        social media posts. We focused on human blood, since that is also the
        focus of our iGEM project. We made the knowledge more accessible through
        visual elements and shorter content length. The posts were made in
        French to reach the local population more easily.
      </p>
      <ImagesCarousel images={imagesDidYouKnow} />
      <div style={{ marginBottom: '-50px' }}></div>
      <References
        references={[
          <span key={1}>
            <i>Bio-Bio-Bio talk show</i>{' '}
            https://open.spotify.com/episode/1j9s5zdmQTINkq0QJT7kH1?si=17791fdc6f6943ec
          </span>
        ]}
      />
    </PageLayout>
  )
}

export default CommAndEducation
